import { PageProps } from "gatsby";
import React, { FC, useMemo } from "react";

import { Skeleton } from "../../skeleton";
import { useEventsLabels } from "../use-events-labels";
import { useGetEventDetail } from "../use-get-event-detail";
import { useGetSubscriptions } from "../use-get-subscriptions";
import { EventDetailContext } from "./event-detail-context";
import { EventDetailInner } from "./event-detail-inner";
import { EventDetailSection } from "./event-detail-section";

export interface EventDetailProps {
  location: PageProps["location"];
}

export const EventDetail: FC<EventDetailProps> = ({ location }) => {
  const searchParams = new URLSearchParams(location.search);
  const eventId = searchParams.get("eventId");

  const labels = useEventsLabels();

  const { error, event, loading } = useGetEventDetail(eventId ?? "");

  const [userSubscriptions] = useGetSubscriptions();

  const subscription = useMemo(
    () => (event ? userSubscriptions.find((sub) => event?.id === sub.eventId) : undefined),
    [event, userSubscriptions]
  );

  return (
    <div className="flex-grow flex flex-col justify-center">
      {loading ? (
        <Skeleton className="w-screen !h-screen" />
      ) : error ? (
        <EventDetailSection title={labels["event-detail-fetch-error"]} />
      ) : event ? (
        <EventDetailContext.Provider value={{ event, labels, subscription }}>
          <EventDetailInner />
        </EventDetailContext.Provider>
      ) : null}
    </div>
  );
};
